
<div class="empty-state-area" >
  <div class="empty-state-area">
    <div class="empty-state-area__icon">
        <ridango-ui-icons name="emptyState" class="margin-bottom-20 inline-block"></ridango-ui-icons>

        <div class="empty-state-area__title">
            <h1 class="page-title" title>{{title | translate}}</h1>
        </div>

        <div class="empty-state-area__description" class="margin-bottom-20">
            <p description>{{description | translate}}</p>
        </div>

        <div class="flex-center empty-state-area__links">
          <ng-content></ng-content>
        </div>
    </div>
  </div>
</div>
